// costsMapper.ts
export const COSTS_KEYS_ORDER = [
    'get_started',
    'scenario_chat',
    'runs_total',
    'property_runs',
    'scenario_runs',
    'chat',
] as const;

export type CostsBreakdownKey = (typeof COSTS_KEYS_ORDER)[number];

export const COSTS_KEY_TO_LABEL: Record<CostsBreakdownKey, string> = {
    get_started: 'Get started',
    scenario_chat: 'Scenario chat',
    runs_total: 'Runs',
    property_runs: 'Property runs',
    scenario_runs: 'Scenario runs',
    chat: 'Chat',
};

type BackendResponse = {

    totals?: { totalUsd?: number; calls?: number };
    breakdown?: Array<{ key: string; label?: string; totalUsd?: number; calls?: number }>;

};

export type UiCosts = {
    totalUsd: number;
    calls: number;
    items: Array<{
        key: CostsBreakdownKey;
        label: string;
        totalUsd: number;
        calls: number;
    }>;
};

export function mapBackendCostsToUi(resp?: BackendResponse): UiCosts {
    const totals = resp?.totals;
    const breakdown = resp?.breakdown ?? [];

    const byKey = new Map<string, { totalUsd: number; calls: number; label?: string }>();
    for (const row of breakdown) {
        byKey.set(row.key, {
            totalUsd: row.totalUsd ?? 0,
            calls: row.calls ?? 0,
            label: row.label,
        });
    }

    const items = COSTS_KEYS_ORDER.map((k) => {
        const row = byKey.get(k);
        return {
            key: k,
            label: COSTS_KEY_TO_LABEL[k] ?? row?.label ?? k,
            totalUsd: row?.totalUsd ?? 0,
            calls: row?.calls ?? 0,
        };
    });
    return {
        totalUsd: totals?.totalUsd ?? 0,
        calls: totals?.calls ?? 0,
        items,
    };
}